import { m, type MithrilVNode } from '../../mithril';
import { Icon } from '../icon';
import { MaterialIcon } from '../icon/icons';
import { addStyles } from '../theme';
import { CSS, Style } from './section.header.style';

addStyles(Style);

export interface SectionHeaderAttrs {
	title: string;
	/** When set the whole header is a collapse toggle; `collapsed` drives the chevron. */
	onToggle?: () => void;
	collapsed?: boolean;
}

/** Presentational section heading (props in, events out, no observable/global reads) so it ports to React later. */
export const SectionHeader = {
	CSS,
	view(attrs: SectionHeaderAttrs): MithrilVNode {
		const { title, onToggle, collapsed } = attrs;
		const content = [
			onToggle == null
				? null
				: Icon.view(collapsed ? MaterialIcon.KEY_RIGHT : MaterialIcon.KEY_DOWN, { className: CSS.chevron }),
			m('span', { className: CSS.title }, title),
		];
		if (onToggle == null) {
			return m('div', { className: CSS.container }, content);
		}
		return m(
			'button',
			{
				type: 'button',
				className: `${CSS.container} ${CSS.toggle}`,
				'aria-expanded': String(collapsed !== true),
				onclick: () => onToggle(),
			},
			content
		);
	},
};
